// extracted by mini-css-extract-plugin
export default {"accordionSummary":"Document_accordionSummary"};